// src/components/ChatHistory.jsx
import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from "./card";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";

const ChatHistory = () => {
  const location = useLocation();
  const {
    setSessionTimeout,
    setAlert,
    setMessage,
  } = useContext(languageContext);

  const [messages, setMessages] = useState([]);

  const chat_history_patient = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/doctor_chat_history",
        JSON.stringify({ id: patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setMessages(response.data.chat_history);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        console.error("Error Details:", error.message);
        setAlert(true);
        setMessage("Please try again later, something went wrong");
      }
    }
  };

  useEffect(() => {
    chat_history_patient();
  }, []);

  return (
    <div className="flex flex-col h-[100vh] "> {/* Ensure full screen height */}
            <Navbar />

    <div className="p-6 bg-gradient-to-tr from-sky-100 via-blue-50 to-white min-h-screen rounded-2xl shadow-inner">
  <h2 className="text-2xl font-bold text-blue-900 mb-6 text-center">Patient Chat History</h2>

  <div className="space-y-4 max-h-[85vh] overflow-y-auto pr-2">
    {messages.length === 0 ? (
      <div className="text-gray-500 text-center py-10 italic">
        No messages found.
      </div>
    ) : (
      messages.map((msg) => (
        <Card key={msg.id} className="border border-blue-100 hover:shadow-lg transition duration-300">
          <CardContent>
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm text-gray-500">🕒 {new Date(msg.timestamp).toLocaleString()}</span>
              <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded-full">
                Message ID: {msg.id}
              </span>
            </div>
            <div className="mb-2">
              <strong className="text-blue-700">Patient:</strong>{" "}
              <span>{msg.user_question || <em className="text-gray-400">[No Question]</em>}</span>
            </div>
            <div>
              <strong className="text-green-700">Bot:</strong>{" "}
              <span>{msg.bot_response || <em className="text-gray-400">[No Response]</em>}</span>
            </div>
          </CardContent>
        </Card>
      ))
    )}
  </div>
</div>
</div>

  );
          }


export default ChatHistory;
